import { Injectable } from '@angular/core';
import { MapStoreService } from './map-store.service';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root',
})
export class BuildingService {
  constructor(private mapStoreService: MapStoreService) {}
  gotoBuilding = (marker: L.Marker, zoom?: number) => this.setView(marker.getLatLng().lat, marker.getLatLng().lng, zoom);

  setView = (lat: any, lng: any, zoom: any, leafmap: L.Map = (this.mapStoreService.map as L.Map)) => leafmap.setView([lat, lng], zoom || leafmap.getMaxZoom() - 1);

  removeMarkerFromCluster = (marker: L.Marker, cluster: L.Map = this.mapStoreService.consumerCluster) => marker.removeFrom(cluster);

  addMarkerToCluster = (marker: L.Marker, cluster: L.Map = this.mapStoreService.consumerCluster) => cluster.addLayer(marker);
}
